import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      id: "icon/action/check_circle_outline_24px",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M32 0C14.336 0 0 14.336 0 32C0 49.664 14.336 64 32 64C49.664 64 64 49.664 64 32C64 14.336 49.664 0 32 0ZM32 57.6C17.888 57.6 6.4 46.112 6.4 32C6.4 17.888 17.888 6.4 32 6.4C46.112 6.4 57.6 17.888 57.6 32C57.6 46.112 46.112 57.6 32 57.6ZM25.5999 38.944L44.4159 20.128C45.6639 18.88 47.7119 18.88 48.9599 20.128C50.2079 21.376 50.2079 23.392 48.9599 24.64L27.8719 45.728C26.6239 46.976 24.6079 46.976 23.3599 45.728L15.0719 37.44C13.8239 36.192 13.8239 34.176 15.0719 32.928C15.6698 32.3288 16.4815 31.992 17.3279 31.992C18.1744 31.992 18.9861 32.3288 19.5839 32.928L25.5999 38.944Z",
      fill: "#5FBB57"
    }, null, -1)
  ])))
}
export default { render: render }